var path = 'areas/projects/actions/Octopus.HealthCheck_summary.html';
var html = "<p> Perform a <span ng-switch on='properties[\"Octopus.Action.HealthCheck.Type\"]'> <span ng-switch-when=FullHealthCheck>full health check</span> <span ng-switch-when=ConnectionTest>connection check</span> </span> <span ng-if='properties[\"Octopus.Action.TargetRoles\"]'> for roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list> </span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.HealthCheck_summary.html
// module id = 1667786946253327
// module chunks = 1